import useTranslations from '../../../hooks/useTranslations'
import ANTDTable from '../../../shared/antd/ANTDTable'
import { isEqual, length } from '../../../utils/javascript'
import { getItem } from '../../../utils/localstorage'

const RepairInstruction = () => {
  const { t } = useTranslations()
  const userDetails = JSON.parse(getItem('userData'))
  const { id: loginUserId } = { ...userDetails }

  const dataSource = [
    {
      key: 1,
      code: 'P0100',
      description: 'inv_RepairInstruction1',
      suggestions: [
        'inv_SuggestedResolution1',
        'inv_SuggestedResolution2',
        'inv_SuggestedResolution3',
      ],
    },
    {
      key: 2,
      code: 'P0200',
      description: 'inv_RepairInstruction2',
      suggestions: [
        'inv_SuggestedResolution4',
        'inv_SuggestedResolution5',
        'inv_SuggestedResolution6',
      ],
    },
    {
      key: 3,
      code: 'P0300',
      description: 'inv_RepairInstruction3',
      suggestions: [
        'inv_SuggestedResolution7',
        'inv_SuggestedResolution8',
        'inv_SuggestedResolution9',
      ],
    },
    {
      key: 4,
      code: 'P0420',
      description: 'inv_RepairInstruction4',
      suggestions: [
        'inv_SuggestedResolution10',
        'inv_SuggestedResolution11',
        'inv_SuggestedResolution12',
      ],
    },
    {
      key: 5,
      code: 'P0128',
      description: 'inv_RepairInstruction5',
      suggestions: [
        'inv_SuggestedResolution13',
        'inv_SuggestedResolution14',
        'inv_SuggestedResolution15',
      ],
    },
    {
      key: 6,
      code: 'P0115',
      description: 'inv_RepairInstruction6',
      suggestions: [
        'inv_SuggestedResolution16',
        'inv_SuggestedResolution17',
        'inv_SuggestedResolution18',
      ],
    },
    {
      key: 7,
      code: 'P0131',
      description: 'inv_RepairInstruction7',
      suggestions: [
        'inv_SuggestedResolution19',
        'inv_SuggestedResolution20',
        'inv_SuggestedResolution21',
      ],
    },
    {
      key: 8,
      code: 'P0301',
      description: 'inv_RepairInstruction8',
      suggestions: [
        'inv_SuggestedResolution22',
        'inv_SuggestedResolution23',
        'inv_SuggestedResolution24',
      ],
    },
    {
      key: 9,
      code: 'P0301',
      description: 'inv_RepairInstruction8',
      suggestions: [
        'inv_SuggestedResolution25',
        'inv_SuggestedResolution26',
        'inv_SuggestedResolution27',
      ],
    },
    {
      key: 10,
      code: 'P0455',
      description: 'inv_RepairInstruction9',
      suggestions: [
        'inv_SuggestedResolution28',
        'inv_SuggestedResolution29',
        'inv_SuggestedResolution30',
      ],
    },
    {
      key: 11,
      code: 'P0500',
      description: 'inv_RepairInstruction10',
      suggestions: [
        'inv_SuggestedResolution31',
        'inv_SuggestedResolution32',
        'inv_SuggestedResolution33',
      ],
    },
  ]

  const columns = [
    {
      title: t('inv_Code'),
      dataIndex: 'code',
      key: 'inv_Code',
    },
    {
      title: t('inv_Description'),
      dataIndex: 'description',
      key: 'inv_Description',
      render: rowData => t(rowData),
    },
    {
      title: t('inv_SuggestedResolution'),
      dataIndex: 'suggestions',
      key: 'inv_SuggestedResolution',
      render: rowData => (
        <ul>
          {rowData.map((str, i) => (
            <li key={i}>{t(str)}</li>
          ))}
        </ul>
      ),
    },
  ]

  const preventiveColumn = [
    {
      title: t('inv_Frequency'),
      dataIndex: 'frequency',
      render: rowData => t(rowData),
    },
    {
      title: t('inv_PreventiveMaintenance'),
      dataIndex: 'preventiveMaintenance',
      render: rowData => t(rowData),
    },
    {
      title: t('inv_Description'),
      dataIndex: 'description',
      key: 'inv_Description',
      render: rowData => t(rowData),
    },
    {
      title: t('inv_Location'),
      dataIndex: 'location',
      key: 'inv_Location',
      render: rowData => (
        <div>
          <span>{rowData?.serviceStation}</span>
          <br />
          <a
            href={rowData?.googleMapsLink}
            className="text-underline"
            target="_blank"
            rel="noreferrer"
          >
            {t('inv_GoogleMaps')}
          </a>
        </div>
      ),
    },
  ]

  const preventiveDataSource = [
    {
      key: 1,
      preventiveMaintenance: 'inv_PreventiveMaintenance1',
      description: 'inv_PreventiveDescription1',
      frequency: 'inv_5Months',
      location: {
        serviceStation: isEqual(loginUserId, 382)
          ? 'Maruti Suzuki Service Center'
          : 'Vehicle Manufacturer Service Center',
        address: '789, Vasant Kunj, Delhi-110070',
        googleMapsLink:
          'https://www.google.com/maps/place/Maruti+Suzuki+Authorised+Service+%28R.S+Automobiles%29/data=!4m7!3m6!1s0x390d1e76bedce689:0x81565df18cffc60a!8m2!3d28.5214559!4d77.1676998!16s%2Fg%2F1q2wgd9fs!19sChIJiebcvnYeDTkRCsb_jPFdVoE?authuser=0&hl=en&rclk=1',
      },
    },
    {
      key: 2,
      preventiveMaintenance: 'inv_PreventiveMaintenance2',
      description: 'inv_PreventiveDescription2',
      frequency: 'inv_10Months',
      location: {
        serviceStation: isEqual(loginUserId, 382)
          ? 'Maruti Suzuki ARENA'
          : 'Vehicle Manufacturer Service Center',
        address: 'Plot No. 1, Sector 10, Gurgaon, Haryana 122001',
        googleMapsLink:
          'https://www.google.com/maps/place/Maruti+Suzuki+ARENA/@28.4679241,77.0302144,15z/data=!4m5!3m4!1s0x0:0x7f5d8d1d8d4f4c7e!8m2!3d28.4679241!4d77.0302144',
      },
    },
    {
      key: 3,
      preventiveMaintenance: 'inv_PreventiveMaintenance3',
      description: 'inv_PreventiveDescription3',
      frequency: 'inv_11Months',
      location: {
        serviceStation: isEqual(loginUserId, 382)
          ? 'Maruti Suzuki True Value'
          : 'Vehicle Manufacturer Service Center',
        address: 'Plot No. 1, Sector 10, Gurgaon, Haryana 122001',
        googleMapsLink:
          'https://www.google.com/maps/place/Maruti+Suzuki+True+Value/@28.4679241,77.0302144,15z/data=!4m5!3m4!1s0x0:0x7f5d8d1d8d4f4c7e!8m2!3d28.4679241!4d77.0302144',
      },
    },
    {
      key: 4,
      preventiveMaintenance: 'inv_PreventiveMaintenance4',
      description: 'inv_PreventiveDescription4',
      frequency: 'inv_6Months',
      location: {
        serviceStation: isEqual(loginUserId, 382)
          ? 'Maruti Suzuki Service Center'
          : 'Vehicle Manufacturer Service Center',
        address: '789, Vasant Kunj, Delhi-110070',
        googleMapsLink:
          'https://www.google.com/maps/place/Maruti+Suzuki+Authorised+Service+%28R.S+Automobiles%29/data=!4m7!3m6!1s0x390d1e76bedce689:0x81565df18cffc60a!8m2!3d28.5214559!4d77.1676998!16s%2Fg%2F1q2wgd9fs!19sChIJiebcvnYeDTkRCsb_jPFdVoE?authuser=0&hl=en&rclk=1',
      },
    },
  ]

  return (
    <>
      <h2 className="mb-10">{t('inv_PreventiveMaintenance')}</h2>
      <ANTDTable
        dataSource={preventiveDataSource}
        columns={preventiveColumn}
        pagination={{
          pageSize: 5,
          total: length(preventiveDataSource) || 0,
        }}
        scroll={{ x: '100%' }}
      />
      <h2 className="mt-15 mb-10">{t('inv_RepairInstructions')}</h2>
      <ANTDTable
        dataSource={dataSource}
        columns={columns}
        pagination={{
          pageSize: 5,
          total: length(dataSource) || 0,
        }}
        scroll={{ x: '100%' }}
      />
    </>
  )
}

export default RepairInstruction
